import React from 'react'
import { CorrectAnswersRow } from './'
import shortid from 'shortid'

export default function AnswerMapHeader({answers, page}) {
  return (
    <thead>
      <tr className="grayBG">
        <th colSpan="2">Question Number</th>
        {
          answers.map((answer, n) => 
            <td key={shortid.generate()}>{n + 1 + (page - 1) * 40}</td>
          )
        }
      </tr>
      <CorrectAnswersRow 
        answers={answers}
      />
      <tr className="grayBG">
				<th>Student</th>
				<th>Scale Score</th>
				{
          answers.map((answer, n) => 
            <td key={shortid.generate()}>&nbsp;</td>
          )
        }
			</tr>
    </thead>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentAnswerMap/AnswerMapHeader.js